export function bearer(token: string) {
  return `Bearer ${token}`;
}

export function openFile(base64: string) {
  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);

  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  const blob = new Blob([bytes], {
    type: "application/pdf",
    endings: "native",
  });
  const url = window.URL.createObjectURL(blob);

  window.open(url, "_blank");

  setTimeout(function () {
    window.URL.revokeObjectURL(url);
  }, 3600000);
}
